import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

interface ClaimModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (nickname: string) => void;
  top10Talents: string[];
}

const ClaimModal: React.FC<ClaimModalProps> = ({ isOpen, onClose, onConfirm, top10Talents }) => {
  const [nickname, setNickname] = useState('');
  const [error, setError] = useState('');

  const handleConfirm = () => {
    const trimmed = nickname.trim();
    if (!trimmed) {
      setError('请输入昵称');
      return;
    }
    if (trimmed.length > 10) {
      setError('昵称不能超过10个字');
      return;
    }
    setError('');
    onConfirm(trimmed);
    setNickname('');
  };

  const handleClose = () => {
    setNickname('');
    setError('');
    onClose();
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          <motion.div
            className="absolute inset-0 bg-black/40"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={handleClose}
          />
          <motion.div
            className="relative bg-white rounded-2xl shadow-2xl max-w-md w-full p-8"
            initial={{ opacity: 0, scale: 0.9, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.9, y: 20 }}
            transition={{ type: 'spring', damping: 25, stiffness: 300 }}
          >
            <h3 className="text-2xl font-bold text-center text-gray-800 mb-2">
              这是你的才干卡片吗？
            </h3>
            <p className="text-center text-gray-500 text-sm mb-6">
              确认认领后，你将拥有这张卡片
            </p>

            <div className="bg-gray-50 rounded-xl p-4 mb-6">
              <p className="text-xs text-gray-400 mb-2 text-center">前10才干预览</p>
              <div className="flex flex-wrap justify-center gap-1.5">
                {top10Talents.map((t, i) => (
                  <span key={t} className="inline-block px-2.5 py-1 bg-[#3A7D78]/10 text-[#3A7D78] text-xs rounded-full font-medium">
                    {i + 1}. {t}
                  </span>
                ))}
              </div>
            </div>

            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1.5">
                输入你的昵称
              </label>
              <input
                type="text"
                value={nickname}
                onChange={(e) => { setNickname(e.target.value); setError(''); }}
                placeholder="10个字以内"
                maxLength={10}
                className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#3A7D78]/30 focus:border-[#3A7D78] transition-all text-gray-800"
                autoFocus
              />
              {error && (
                <p className="text-red-400 text-xs mt-1">{error}</p>
              )}
            </div>

            <div className="flex gap-3">
              <button
                onClick={handleClose}
                className="flex-1 py-3 rounded-xl border border-gray-200 text-gray-500 font-medium hover:bg-gray-50 transition-colors"
              >
                取消
              </button>
              <button
                onClick={handleConfirm}
                className="flex-1 py-3 rounded-xl bg-[#3A7D78] text-white font-medium hover:bg-[#2E6B67] transition-colors"
              >
                确认认领
              </button>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default ClaimModal;
